import React from 'react';
import type { UserDetailsResponse } from '../../schemas/validation';
import { formatDate, getStatusColor, getEngagementColor } from './utils';

interface AccountInfoCardProps {
  auth: UserDetailsResponse['data']['auth'];
  statistics: UserDetailsResponse['data']['statistics'];
  insights: UserDetailsResponse['data']['insights'];
}

export const AccountInfoCard: React.FC<AccountInfoCardProps> = ({ auth, statistics, insights }) => {
  return (
    <div className="bg-white shadow rounded-lg">
      <div className="px-6 py-4 border-b border-gray-200">
        <h3 className="text-lg font-medium text-gray-900">Account Information</h3>
      </div>
      <div className="px-6 py-4">
        <dl className="grid grid-cols-1 gap-x-4 gap-y-6 sm:grid-cols-2">
          <div>
            <dt className="text-sm font-medium text-gray-500">Account Created</dt>
            <dd className="mt-1 text-sm text-gray-900">{formatDate(auth.accountCreated)}</dd>
          </div>
          <div>
            <dt className="text-sm font-medium text-gray-500">Last Updated</dt>
            <dd className="mt-1 text-sm text-gray-900">{formatDate(auth.profileLastUpdated)}</dd>
          </div>
          <div>
            <dt className="text-sm font-medium text-gray-500">Account Status</dt>
            <dd className="mt-1">
              <span
                className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getStatusColor(auth.accountStatus)}`}
              >
                {auth.accountStatus.charAt(0).toUpperCase() + auth.accountStatus.slice(1)}
              </span>
            </dd>
          </div>
          <div>
            <dt className="text-sm font-medium text-gray-500">Email Verified</dt>
            <dd className="mt-1">
              <span
                className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${auth.emailVerified ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}
              >
                {auth.emailVerified ? 'Verified' : 'Not Verified'}
              </span>
            </dd>
          </div>
          <div>
            <dt className="text-sm font-medium text-gray-500">Account Age</dt>
            <dd className="mt-1 text-sm text-gray-900">{statistics.accountAge} days</dd>
          </div>
          <div>
            <dt className="text-sm font-medium text-gray-500">Engagement Level</dt>
            <dd className="mt-1">
              <span
                className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getEngagementColor(insights.engagementLevel)}`}
              >
                {insights.engagementLevel.charAt(0).toUpperCase() +
                  insights.engagementLevel.slice(1)}
              </span>
            </dd>
          </div>
        </dl>
      </div>
    </div>
  );
};
